var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedley({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.11 260.13c-15.3 0-27.99-12.69-27.99-27.99s12.69-27.99 27.99-27.99h447.78c15.3 0 27.99 12.69 27.99 27.99s-12.69 27.99-27.99 27.99H288.11zM400.06 166.84c-15.3 0-27.99-12.69-27.99-27.99s12.69-27.99 27.99-27.99h223.89c15.3 0 27.99 12.69 27.99 27.99s-12.69 27.99-27.99 27.99H400.06z",
    fill: "#2B8CF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.11 325.43c-82.09 0-149.26 67.17-149.26 149.26v261.2c0 82.09 67.17 149.26 149.26 149.26h447.78c82.09 0 149.26-67.17 149.26-149.26v-261.2c0-82.09-67.17-149.26-149.26-149.26H288.11z",
    fill: "#A4D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M573.18 424.32L471.31 452.3c-31.72 8.21-52.24 35.07-52.24 68.28v130.61c-7.46-2.24-14.93-3.73-23.13-3.73-43.66 0-79.11 35.45-79.11 79.11s35.45 79.11 79.11 79.11 79.11-35.45 79.11-79.11V601.93l131.35-35.82v51.12c-7.46-2.24-14.93-3.73-23.14-3.73-43.66 0-79.11 35.45-79.11 79.11s35.45 79.11 79.11 79.11c42.91 0 77.99-34.33 78.74-77.24 0-0.75 0.37-1.12 0.37-1.87V492.97c0-33.58-13.43-51.12-24.63-59.7-11.2-8.95-31.72-17.53-64.56-8.95zM372.8 726.19c0-12.69 10.45-23.13 23.13-23.13s22.76 10.07 23.13 22.76c0 13.06-10.45 23.51-23.13 23.51s-23.13-10.45-23.13-23.14z m187.32-33.95c0-12.69 10.45-23.13 23.13-23.13s23.14 10.45 23.14 23.13-10.45 23.13-23.14 23.13-23.13-10.45-23.13-23.13z",
    fill: "#2B8CF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedley);
export default __webpack_public_path__ + "static/media/medley.de55cec1.svg";
export { ForwardRef as ReactComponent };